import React, { Fragment, useState } from "react";
import { isNumber } from "lodash";
import { formatWithCommas } from "../../Utils/Toast";
import BetSlipSky from "./MatchDetail/BetSlipSky";
import RenderOddsSky from "./MatchDetail/RenderOddsSky";
import { useFavMatchOddsLogic } from "../useLogic/useFavMatchOddsLogic";

const SelectionFav = (props) => {
  const {
    object,
    totalMatched,
    ms,
    backOdds,
    layOdds,
    betSlipObject,
    showBetDialog,
    user,
    setShowBetDialog,
    setBetSlipObject,
    setToastObject,
    defaultStakeLimit,
    profileData,
    setLimit,
    position,
    oldBack,
    oldLay,
    addToFavioute,
  } = props;
  let typeGame = "betFaire";
  const { runner, handelChange, localLimit, checkArrays } = useFavMatchOddsLogic({
    object,
    betSlipObject,
    showBetDialog,
    user,
    setShowBetDialog,
    setBetSlipObject,
    setToastObject,
    defaultStakeLimit,
    profileData,
    setLimit,
    position,
    totalMatched,
  });
  return (
    <div
      id="marketBetsWrap"
      className={`bets-wrap asiahadicap ${ms != 1 ? "disabled" : ""} `}
    >
      <dl id="betsHead" className="bets-selections-head">
        <dt>
          <div
            onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
              addToFavioute(
                object?.eventId,
                "Match Odds",
                object?.marketId,
                object?.eventType,
                object?.market
              );
            }}
            className="a-depth"
            id="marketDepthBtn"
          >
            Markets Depth
          </div>
          <p>
            <span>{object?.market}</span>
            <strong id="totalMatched">
              PTH {formatWithCommas(totalMatched)}
            </strong>
          </p>
        </dt>
        <dd className="mode-land" />
        <dd className="mode-land" />
        <dd>Back</dd>
        <dd>Lay</dd>
        <dd className="mode-land" />
        <dd className="mode-land" />
      </dl>
      {runner?.map((item, index) => {
        const odds_back = backOdds?.filter(
          (todd) => todd.ri === item.SelectionId
        );
        const odds_lay = layOdds?.filter(
          (todd) => todd.ri === item.SelectionId
        );
        const old_back = oldBack?.filter(
          (todd) => todd.ri === item.SelectionId
        );
        const old_lay = oldLay?.filter((todd) => todd.ri === item.SelectionId);
        let disabelBack = "lockBackBets" in item ? item?.lockBackBets : false;
        let disabelLay = "lockLayBets" in item ? item?.lockLayBets : false;
        let disableFull = checkArrays(
          odds_back?.slice(0, 1),
          odds_lay?.slice(0, 1),
          localLimit
        );
        let showPosition =
          (isNumber(item?.position) &&
            position?.length > 0 &&
            Math.abs(item?.position) > 0) ||
          (Math.abs(item?.newPosition) >= 0 &&
            showBetDialog &&
            betSlipObject?.playType == typeGame &&
            object?.marketId == betSlipObject?.object?.newMarketId);

        return (
          <Fragment>
            <dl
              id="selection_247650_0_00"
              className="bets-selections"
              style={{ display: "flex" }}
            >
              <dt>
                <h4 id="runnerName"> {item?.RunnerName || item?.runnerName}</h4>
                {showPosition && (
                  <ul id="winLoss">
                    {isNumber(item?.position) &&
                      position?.length > 0 &&
                      Math.abs(item?.position) > 0 && (
                        <li
                          id="withoutBet"
                          className={item?.position > 0 ? "win" : "lose"}
                        >
                          {isNumber(item?.position) &&
                          Math.abs(item?.position) > 0
                            ? item?.position > 0
                              ? Math?.abs(item?.position).toFixed(2)
                              : `(${Math.abs(item?.position).toFixed(2)})`
                            : ""}
                        </li>
                      )}
                    {Math.abs(item?.newPosition) >= 0 &&
                      showBetDialog &&
                      betSlipObject?.playType == typeGame &&
                      object?.marketId ==
                        betSlipObject?.object?.newMarketId && (
                        <li
                          id="withBet"
                          className={`to-${
                            item?.newPosition > 0 ? "win" : "lose"
                          }`}
                        >
                          {item?.newPosition > 0
                            ? Math.abs(item?.newPosition).toFixed(2)
                            : `(${Math.abs(item?.newPosition).toFixed(2)})`}
                        </li>
                      )}
                  </ul>
                )}
              </dt>

              <RenderOddsSky
                component={typeGame}
                index={index}
                item={item}
                disabelBack={disabelBack}
                oldBack={old_back}
                oldLay={old_lay}
                disableFull={disableFull}
                disabelLay={object?.market == "Win" ? true : disabelLay}
                isInPlay={
                  ["Win", "Winner"].includes(object?.market)
                    ? true
                    : object?.status == "in_play"
                    ? true
                    : false
                }
                handelChange={handelChange}
                odds_lay={odds_lay}
                odds_back={odds_back}
                limit={localLimit}
                ms={ms}
                betType={betSlipObject?.betType}
                active={
                  showBetDialog &&
                  object?.marketId == betSlipObject?.newMarketId &&
                  item?.SelectionId == betSlipObject?.object?.SelectionId &&
                  typeGame == betSlipObject?.playType
                }
              />
            </dl>
            {showBetDialog &&
              betSlipObject?.playType == typeGame &&
              object?.marketId == betSlipObject?.object?.newMarketId &&
              betSlipObject?.object?.SelectionId == item?.SelectionId && (
                <BetSlipSky />
              )}
          </Fragment>
        );
      })}
    </div>
  );
};

export default React.memo(SelectionFav);
